export default __webpack_public_path__ + "static/O0255-a68facf18daea8f41908369f62295ce3.png";